import type { ProductImageProps } from "../types/components/ProductImageProps";
import { CountryDelivery } from "./CountryDelivery";
import { Image } from "./Image";

import "../assets/scss/components/_product-image.scss";
import { ProductOverlays } from "./ProductOverlays";

export const ProductImage = ({
	image,
	overlayType = "",
	overlayValue = "",
	alt = "",
	lazy = false,
	fetchPriority = "auto",
	availableCountries = {},
}: ProductImageProps) => {
	return (
		<div className="product-image row align-items-center">
			{/* <Placeholder check={image}> */}
			<ProductOverlays type={overlayType} value={overlayValue} />
			<CountryDelivery availableCountries={availableCountries} />
			{image !== "" && (
				<Image
					src={image}
					alt={alt}
					srcSetWidths={[200, 400]}
					loading={lazy ? "lazy" : "eager"}
					fetchPriority={fetchPriority}
					title={alt}
				/>
			)}
			{/* </Placeholder> */}
		</div>
	);
};
